import $ from "jquery";
import debug from "bows";
const log = debug("ajaxForm");

export function ajaxForm(opts) {
	const { $form, $list, action, loadMoreSelector = 'button', callbacks } = opts;
	let paged = 1;
	let prevSearch = null;

	log('Watching...', $form, $list);

	const submit = (e) => {
		e.preventDefault();
		if ( isLocked() ) {
			return;
		}

		if ( callbacks['submit'] && typeof callbacks['submit'] === 'function' ) {
			callbacks['submit']();
		}

		// Ajax request with replace
		ajax(replace);
	}

	const loadMore = (e) => {
		if ( isLocked() ) {
			return;
		}

		if ( callbacks['loadMore'] && typeof callbacks['loadMore'] === 'function' ) {
			callbacks['loadMore']();
		}

		// Update page number
		paged = $list.find(loadMoreSelector).data('paged');

		// Ajax request with append
		ajax(append);
	}

	const ajax = (done) => {
		lock();

		let search = $form.find("input[name='s']");

		// update paged value - only load more
		if ($list.find(loadMoreSelector).length) {
			$form.find("input[name='paged']").val(parseInt(paged));
		}

		let campaign = $form.find("select[name='campaign-resource-type']");
		let data = $form.serialize();

		prevSearch = search.val();

		let options = {
			dataType: 'json',
			url: action,
			data: data,
		}

		// Campaign page uses POST
		if ( window.location.pathname.includes('/marketing-campaigns/')) {
			options.method = 'POST';
			options.headers = {
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// AJAX call
		$.ajax( options ).done(function ( response ) {
			if ( response && response.success ) {
				if ( callbacks['done'] && typeof callbacks['done'] === 'function' ) {
					callbacks['done'](response);
				}
				done(response.data);
			}
		}).fail(function () {
			if ( callbacks['fail'] && typeof callbacks['fail'] === 'function' ) {
				callbacks['fail']();
			}
			alert('Please try again!');
		}).always(function () {
			unlock();
		});


	}

	const isLocked = () => {
		return $form.data('locked');
	}

	const lock = () => {
		$form.data('locked', true);
		$form.css('opacity', 0.5);
		$list.find(loadMoreSelector).css('opacity', 0.5);
	}

	const unlock = () => {
		$form.css('opacity', 1);
		$form.data('locked', null);
		$list.find(loadMoreSelector).css('opacity', null);
	}

	const replace = (html) => {
		$list.empty().append(html);
		if ( callbacks['replace'] && typeof callbacks['replace'] === 'function' ) {
			callbacks['replace']();
		}
	}

	const append = (html) => {
		$list.find(loadMoreSelector).remove();
		$list.append(html);
		if ( callbacks['append'] && typeof callbacks['append'] === 'function' ) {
			callbacks['append']();
		}
	}

	// Attach submit event
	$form.on('submit', (e) => submit(e));

	if ( loadMoreSelector ) {
		// Attach delegated load more event
		$list.on('click', loadMoreSelector, (e) => loadMore(e));
	}

}

// Public
window.ajaxForm = ajaxForm;

export default {
	ajaxForm
};
